import { getAuthSessionData, getExtJWTUserData } from "../api";
import _ from "lodash";
import { DateTime } from "luxon";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

export const AuthHoc = (WrappedComponent) => {
  const AuthComp = (props) => {
    const [user, setUser] = useState(null);
    const { auth0, authVendor, withAuth, extAuthData } = props;

    useEffect(() => {
      if (!withAuth) {
        return;
      }

      if (user) {
        return;
      }

      if (auth0) {
        auth0.getUser().then((usr) => {
          if (authVendor === "MSN") {
            auth0.getIdTokenClaims().then((data) => {
              const token = _.get(data, "__raw");

              if (token) {
                getExtJWTUserData({
                  jwt: data.__raw,
                  endpoint: extAuthData,
                }).then((data) => {
                  setUser({ ...usr, extUser: data, username: usr.name });
                });
              }
            });
          } else {
            setUser(usr);
          }
        });
      }

      if (authVendor === "CEN") {
        const auth_data = getAuthSessionData();
        setUser(auth_data.user_meta);
      }
    }, []);

    return <WrappedComponent {...props} user={user} />;
  };

  AuthComp.defaultProps = {
    extAuthData: "",
    auth0: null,
    authVendor: "",
    withAuth: false,
  };

  AuthComp.propTypes = {
    extAuthData: PropTypes.string.isRequired,
    auth0: PropTypes.object,
    authVendor: PropTypes.string.isRequired,
    withAuth: PropTypes.bool.isRequired,
  };

  return AuthComp;
};

export const AuthMetaHoc = (WrappedComponent) => {
  const AuthMetaComp = (props) => {
    const { user, authVendor } = props;
    var trial_expiration = null;
    var on_trial = false;
    var subscription_expiration = null;
    var on_subscription = false;

    if (authVendor === "MSN") {
      if (_.get(user, "extUser.trial_end_date")) {
        trial_expiration = DateTime.fromISO(
          _.get(user, "extUser.trial_end_date")
        ).toLocaleString(DateTime.DATETIME_FULL);

        on_trial =
          DateTime.fromISO(_.get(user, "extUser.trial_end_date")) >
          DateTime.now();
      }

      if (_.get(user, "extUser.subscription.end_date")) {
        const start = DateTime.fromISO(
          _.get(user, "extUser.subscription.start_date")
        );
        const end = DateTime.fromISO(
          _.get(user, "extUser.subscription.end_date")
        );
        on_subscription = start <= DateTime.now() && DateTime.now() <= end;
        subscription_expiration = end.toLocaleString(DateTime.DATETIME_FULL);
      }
    }

    var customer_email, customer_stripe_id;
    if (user && authVendor === "MSN") {
      customer_email = user.email;
      customer_stripe_id = _.get(user, "extUser.stripe_customer_id");
    } else if (user && authVendor === "CEN") {
      customer_email = user.email;
    }

    const extra_props = {
      on_subscription,
      subscription_expiration,
      on_trial,
      trial_expiration,
      customer_email,
      customer_stripe_id,
    };

    props["user"] = user;

    return <WrappedComponent {...{ ...extra_props, ...props }} user={user} />;
  };

  AuthMetaComp.propTypes = {
    user: PropTypes.object,
    authVendor: PropTypes.string.isRequired,
  };

  return AuthMetaComp;
};
